import React from 'react'; // قمت بتبسيط الاستيرادات غير المستخدمة
import './AvailableJobs.css';
import { IoChevronBackOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { useJobs } from '../../hooks/useJobs';

const AvailableJobs = ({ searchTerm }) => {
    const { jobs, loading, error } = useJobs();

    const filteredJobs = jobs.filter(job =>
        job.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (loading) {
        return (
            <section className='available-jobs'>
                <div className='container text-center py-5'>
                    <p>جاري تحميل الوظائف...</p>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className='available-jobs'>
                <div className='container text-center py-5'>
                    <p className='text-danger'>{error}</p>
                </div>
            </section>
        );
    }

    return (
        <section className='available-jobs'>
            <div className='container'>
                <div className="row" id="jobCardsContainer">
                    {filteredJobs.length > 0 ? (
                        filteredJobs.map((job) => (
                            <div className="col-lg-5" key={job.id}>
                                <div className="job-card">

                                    {/* ==== هذا هو السطر الذي تم إصلاحه ==== */}
                                    <img src={job.image_url || require('../../assets/jobdimage.jpeg')} className="img-fluid" alt={job.title} />

                                    <div className="job-details">
                                        <h5 className="job-title">{job.title}</h5>
                                        <p>{job.short_description}</p>
                                        <Link to={`/details/${job.id}`} className="read-details">
                                            اقرأ التفاصيل
                                            <IoChevronBackOutline />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center">
                            <p>لا توجد وظائف تطابق بحثك حالياً.</p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default AvailableJobs;